import { Link } from "react-router-dom"
import { useRecoilState } from "recoil"
import styled from "styled-components"
import { langText } from "../../../lang-text/langText"
import { langState } from "../../../state/langState"
import { B1 } from "../../../style/constant"

const Header = () => {
  const [currentLang,setCurrentLang] = useRecoilState(langState)

  const Text = currentLang ? langText.ko.header : langText.en.header

  const handleLanguageClick = () => {
    setCurrentLang(!currentLang)
  }

  return(
    <Container>
      <MainLogo>
        <Link to =""><img src ={"/imgs/header/mainLogo.png"} alt="tram_logo" /></Link>
      </MainLogo>

        <Wrap>
          <Navbar>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
          </Navbar>
          
          <LanguageArea onClick = {handleLanguageClick} >
            <Globe src={"/imgs/header/globe.png"} alt=""/>
            <Language>{Text.language}</Language>
          </LanguageArea>
        </Wrap>

    </Container>
  )
}


export default Header


const Container = styled.header`
  display: flex;
  align-items: center;
  width:1200px;
  height:92px;
  margin:0 auto;
`


const MainLogo = styled.h1`
  img{
    width:150px;
    height:20px;
  }
`

const Wrap = styled.div`
  display: flex;
`

const Navbar = styled.nav`
  margin-left:682px;
  li{
    display: inline-block;
    ${B1};
    margin-right: 47px;
  }
`

const LanguageArea = styled.div`
  display: flex;
  align-items: center;
  cursor:pointer;
  margin-left:54px;
`

const Globe = styled.img`
  width:24px;
  height:24px;
  margin-right:10px;
`

const Language = styled.p`
  ${B1}
`